import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth';
import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue';
import VModal from 'vue-js-modal';
import Spinner from '@/components/common/Spinner.vue';
import apolloProvider from '@/api/apollo';
import router from './router';
import App from './App.vue';


Vue.use(VModal);
Vue.use(BootstrapVue);
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.component('Spinner', Spinner);
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '';
  next();
});
Vue.router = router;

Vue.use(VueAuth, {
  auth: require('./components/auth/tokenBehaviour'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'role',
  authRedirect: { path: '/' },
  loginData: {
    url: 'auth',
    method: 'POST',
    redirect: '/',
    fetchUser: true,
  },
  parseUserData(data) {
    return data;
  },
  fetchData: {
    url: 'auth/current',
    method: 'GET',
    enabled: true,
  },
  refreshData: {
    url: 'auth/refresh',
    method: 'POST',
    enabled: true,
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  apolloProvider,
  render: h => h(App),
}).$mount('#app');
